module.exports = __webpack_public_path__ + "img/HC1004-19.3d752ee8.jpg";